import { type ISettingModel } from 'tno-core';

export const defaultSetting: ISettingModel = {
  id: 0,
  name: '',
  description: '',
  isEnabled: true,
  sortOrder: 0,
  value: '',
};
